import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b54be91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ConstructionInfo" }
const _hoisted_2 = { class: "info block-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "施工申请情况", -1))
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "block-tit",
  style: {"padding-top":"10px"}
}, "进场施工安装条件", -1))
const _hoisted_6 = { class: "block-con" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "submit-btn"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "submit-btn"
}

import { flowsItem, projectItem, Approve } from '@/apis/base'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let projectInfo = JSON.parse(localStorage.getItem('PROJECT_DETAIL'))

const router = useRouter()
const type_name = ref('--')
const constructionDetails = ref({
  finish_date: '', // 完工时间
  sqdd_state: 0, //水气电道路1已通 2未通
  disburden_person: '--', // 卸货负责人
  prepare_state: 0, // 1已准备 2未准备
  explain: '', // 其他说明
  liable_person: '--', // 现场负责人
  phone: '--', // 现场负责人电话
  tabsActive: 0, // 已发起
  supply_days: '', // 供货期限
  address: '--', // 项目地址
  nocontract_explain: '', // 无合同说明
  pics: null, // 图片
  approve_state: 0, // 审批状态
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  approve: {} as Approve,
  project: {} as projectItem,
  flows: Array<flowsItem>()
})

const showBottom = ref(false)

const StaffInfo = ref({
  id: 0,
  name: '',
  avatar: ''
})

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  constructionDetails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  constructionDetails.value.finish_date = projectInfo?.contract?.finish_date
  type_name.value = router.currentRoute.value.query.type_name.toString()
  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_BottomButtonTwo = _resolveComponent("BottomButtonTwo")!
  const _component_BottomButtonOne = _resolveComponent("BottomButtonOne")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_DetailTitle, {
      approve: constructionDetails.value.approve
    }, null, 8, ["approve"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: constructionDetails.value?.project?.name,
              size: "large"
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "施工申请情况",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "施工地址",
              value: constructionDetails.value.address
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "完工时间",
              value: constructionDetails.value.finish_date
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "施工负责人",
              value: constructionDetails.value.liable_person
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "联系电话",
              value: constructionDetails.value.phone
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_cell_group, { border: false }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "现场水电气道路情况",
              value: constructionDetails.value.sqdd_state == 1 ? '已通' : '未通'
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "计划供货期限",
              value: constructionDetails.value.supply_days
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "现场卸货负责人",
              value: constructionDetails.value.disburden_person
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "安装用物料准备情况",
              value: constructionDetails.value.prepare_state == 1 ? '已准备' : '未准备'
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "其他说明：",
              value: constructionDetails.value.explain
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_ApprovalProcess, {
      flows: constructionDetails.value.flows
    }, null, 8, ["flows"]),
    (constructionDetails.value.tabsActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (constructionDetails.value.approve.approve_staff?.id === StaffInfo.value.id && constructionDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonTwo, {
                      key: 0,
                      typeId: constructionDetails.value.type_id,
                      itemId: constructionDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (constructionDetails.value.tabsActive == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (constructionDetails.value.approve.staff_id === StaffInfo.value.id && constructionDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonOne, {
                      key: 0,
                      typeId: constructionDetails.value.type_id,
                      itemId: constructionDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})